"use client"

import { Button, Divider, DialogActions, CircularProgress } from "@mui/material"

export function DrawerFooter({ actions, gap = 1 }) {
  return (
    <>
      <Divider />
      <DialogActions sx={{ p: 2, flexDirection: "column", gap }}>
        {actions.map((action, index) => (
          <Button
            key={index}
            onClick={action.onClick}
            fullWidth
            variant={action.variant || "contained"}
            disabled={action.disabled || action.loading}
            sx={{ py: 1.5 }}
          >
            {action.loading ? (
              <>
                <CircularProgress size={20} sx={{ mr: 1 }} color="inherit" />
                {action.label}
              </>
            ) : (
              action.label
            )}
          </Button>
        ))}
      </DialogActions>
    </>
  )
}
